export default {
  $id: "ShiftPatternSchema",
  type: "object",
  required: ["name", "startDay"],
  properties: {
    name: {
      type: "string",
      title: "Name",
      max_length: 100,
    },
    days: {
      type: "integer",
      title: "Days",
      minimum: 7,
      maximum: 7,
    },
    startDay: {
      type: "string",
      title: "Start Day",
      oneOf: [
        {
          title: "Monday",
          const: "MON",
        },
        {
          title: "Tuesday",
          const: "TUE",
        },
        {
          title: "Wednesday",
          const: "WED",
        },
        {
          title: "Thursday",
          const: "THU",
        },
        {
          title: "Friday",
          const: "FRI",
        },
        {
          title: "Saturday",
          const: "SAT",
        },
        {
          title: "Sunday",
          const: "SUN",
        },
      ],
    },
  },
};
